import { AxiosResponse } from "axios";
import LoginData from "../../model/loginData";
import api from "../../utils/api";

import routes from "../../utils/apiRoutes.json";

export function init(setStates: Function): Promise<void> {
    // Add here other things need for initiating the app
    return defaultLogin(setStates);
}

export function defaultLogin(setAppStates: Function): Promise<void> {
    let username: string | null;
    let password: string | null;
    let soundEffects: string | null = localStorage.getItem("soundEffect");
    let sound: string | null = localStorage.getItem("sound");
    username = localStorage.getItem("username");
    password = localStorage.getItem("password");
    if (!username)
        username = sessionStorage.getItem("username");
    if (!password)
        password = sessionStorage.getItem("password");
    if (!soundEffects)
        soundEffects = sessionStorage.getItem("soundEffect");
    if (!sound)
        sound = sessionStorage.getItem("sound");
    if (username === null || password === null) {
        setAppStates(false, false);
        return new Promise((resolve) => resolve());
    }
    if (sound === null) sound = "true";
    if (soundEffects === null) soundEffects = "true";
    return api.post<LoginData>(
        routes.login,
        {
            username: username,
            password: password,
        },
    ).then((response) => {
        if (response.status === 200)
            setAppStates(false, true, response.data.id, (sound === "true"), (soundEffects === "true"));
        else
            setAppStates(false, false);
    },
    ).catch((err) => {
        setAppStates(false, false);
        throw err;
    });
}

export function loginError(username: string, password: string, setError: Function, rememberMe: boolean): Promise<AxiosResponse> {
    setError("login-form.loading");
    return api.post(
        routes.login,
        {
            username: username,
            password: password,
        },
    ).then((response) => {
        if (response.status === 200) {
            if (rememberMe) {
                localStorage.setItem("username", username);
                localStorage.setItem("password", password);
            }
            sessionStorage.setItem("username", username);
            sessionStorage.setItem("password", password);
            sessionStorage.setItem("id", response.data.id);
            if (setError) setError("");
        } else if (setError) setError("login-form.error");
        return response;
    },
    ).catch((err) => {
        if (setError) setError("login-form.error");
        throw err;
    },
    );
}

export function logout(): Promise<AxiosResponse> {
    return api.post(
        routes.logout,
    ).then((response) => {
        localStorage.clear();
        sessionStorage.clear();
        return response;
    },
    ).catch((err) => {
        throw err;
    });

}
